import styled from 'styled-components';

export const Container = styled.div`
  background: #403d52;
  width: 100%;
  display: flex;
  padding: 1.5em;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;

  span {
    margin-right: 0.2em;
    color: #ffffff;
  }

  a {
    color: #ffffff;
    font-weight: 600;
  }
`;
